export default {
	pathoreq: 'Pathology Request',
	xc_patho: 'Pathology Request',
	medcert: 'Medical Certificate',
	docrefr: 'Doctor Referral',
	doclett: 'Doctor Letter',
	sleeprefr: 'Doctor Sleep Referral',
	medimgreq: 'Medical Imaging'
};